<template>
  <router-view />
</template>

<script>
export default {
  name: 'BasketsWrapper',
};
</script>
